// src/config/firebase.ts
import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import { connectFunctionsEmulator, getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// The local stack (DEVELOPMENT.md) runs the real rules and functions under the
// `vomm-dev` project id. Setting VITE_USE_EMULATORS=1 points the browser at it,
// so a change can be driven end to end without touching production. Dev builds
// only: a production bundle can never be aimed at an emulator by an env var.
export const usingEmulators = import.meta.env.DEV && import.meta.env.VITE_USE_EMULATORS === '1';

const firebaseConfig = {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "AIzaSyDssboQ4CjH6gAg3tc2nNtr4tP7tez4Pqg",
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "vomm-eesti.firebaseapp.com",
    projectId: usingEmulators ? 'vomm-dev' : (import.meta.env.VITE_FIREBASE_PROJECT_ID || "vomm-eesti"),
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "vomm-eesti.firebasestorage.app",
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "157866958098",
    appId: import.meta.env.VITE_FIREBASE_APP_ID || "1:157866958098:web:aa5800f0bdb3baf160a7cb"
};

const app = initializeApp(firebaseConfig);

// App Check attests that requests come from this app rather than a script holding the
// public project id. It stays inert until VITE_APPCHECK_SITE_KEY is provided, because
// arming it requires a reCAPTCHA key that has to be created in the Firebase console.
const appCheckSiteKey = import.meta.env.VITE_APPCHECK_SITE_KEY;
if (appCheckSiteKey && !usingEmulators) {
    initializeAppCheck(app, {
        provider: new ReCaptchaV3Provider(appCheckSiteKey),
        isTokenAutoRefreshEnabled: true,
    });
} else if (import.meta.env.PROD) {
    console.warn('App Check is not configured: set VITE_APPCHECK_SITE_KEY to enable it.');
}

export const auth = getAuth(app);
export const firestore = getFirestore(app);
// Callables are deployed to europe-west1 alongside the scheduled functions.
export const functions = getFunctions(app, 'europe-west1');

if (usingEmulators) {
    // Ports match firebase.json. Must run before any request is made.
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
    connectFirestoreEmulator(firestore, '127.0.0.1', 8085);
    connectFunctionsEmulator(functions, '127.0.0.1', 5001);
}
